module.exports = __webpack_public_path__ + "img/over-38-billion-mobile.b3143003.svg";